<template>

    <div class="source-group">
        <el-select class="source-item" v-model="query.source_id" placeholder="渠道" @change="getSourceId" filterable
            clearable>
            <el-option v-for="(item, index) in list" :key="'source'+index" :label="item.title"
                :value="item.id"></el-option>
        </el-select>

        <el-select class="source-item" v-model="query.account_city_id" placeholder="区域" @change="changeAccountCity"
            filterable clearable>
            <el-option v-for="(row, index) in sourceAccount.accountCity" :key="'account_city_id'+index"
                :label="dictionary.getRegionItem(row, '无')" :value="row"></el-option>
        </el-select>

        <el-select class="source-item" v-model="query.account_id" placeholder="账户" filterable clearable>
            <el-option v-for="row in sourceAccount.accountList" :key="'account_id:'+row.id" :label="row.title"
                :value="row.id"></el-option>
        </el-select>
    </div>

</template>

<script>
import {
    post
} from '@/api/http.js';
import dictionary from '@/utils/dictionary.js';
export default {
    props: {
        query: {
            type: Object,
            default: function () {
                return {};
            }
        },
    },
    data() {
        let accountPickerList = dictionary.getPicker('account');
        return {
            accountPickerList: accountPickerList,
            sourceAccount: {
                accountCity: [], //来源区域
                accountList: [], //来源账户
            },
            list: []
        };
    },
    beforeMount() {
        this.dictionary = dictionary;
    },
    created() {
        this.getSourceList();
    },
    methods: {
        // 获取下拉列表
        getSourceList() {
            let url = '/api/customer.picker/items';
            let that = this;
            this.$post(url, {}).then(function (response) {
                let result = response.data;
                that.list = result.sourceList.filter((item) => item.is_valid == 1);
            });
        },
        toggleSelector() {
            this.$emit('input', this.selectVal);
        },
        // 选择来源
        getSourceId(id) {
            this.query.source_id = id;
            this.query.account_city_id = '';
            this.query.account_id = '';
            this.sourceAccount.accountCity = [];
            this.sourceAccount.accountList = [];
            this.showCity = false;
            let accountSourceList = [];
            let cityArr = [];
            this.accountPickerList.forEach((item, index) => {
                if (item.source_id == id) {
                    accountSourceList.push(item);
                }
            });
            this.accountSourceList = accountSourceList;
            this.accountSourceList.forEach((item, index) => {
                cityArr.push(item.city_id);
            });
            // 城市去重
            cityArr.sort();
            let newCityArr = [cityArr[0]];
            for (var i = 0; i < cityArr.length; i++) {
                if (cityArr[i] !== newCityArr[newCityArr.length - 1]) {
                    newCityArr.push(cityArr[i]);
                }
            }
            this.sourceAccount.accountCity = newCityArr;
            // 没有区域直接选账号
            if (this.sourceAccount.accountCity.length == 1 && this.sourceAccount.accountCity[0] == 0) {
                this.sourceAccount.accountList = this.accountSourceList;
                if (this.sourceAccount.accountList.length) {
                    this.showCity = true;
                }
            }
            // 区域只有无并且无匹配账号
            if (this.sourceAccount.accountCity.length == 1 && !this.sourceAccount.accountCity[0] && !this
                .sourceAccount.accountList.length) {
                this.showCity = true;
            }
        },
        // 来源城市匹配账号
        changeAccountCity(id) {
            this.query.account_city_id = id;
            this.query.account_id = '';
            let accountList = [];
            accountList = this.accountSourceList.filter(item => item.city_id == id && item.source_id == this.query.source_id);
            this.sourceAccount.accountList = accountList;
        },
    }
};
</script>

<style lang="less" scoped>
.source-group {
    display: inline-block;
    .source-item {
        margin-bottom: 8px;
        margin-right: 10px;
    }

    .source-item:last-child {
        margin-bottom: 0;
    }
}
</style>
